import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem, imageClassName } from '@archipro-design/aria';

export const Container: StyleRule = ({ theme }) => ({
    transform: 'translateY(-50%)',
    background: theme.siteVariables.colors.primitive.white,
    position: 'relative',
    flexDirection: 'column',
    width: pxToRem(236),
    padding: pxArrayToRem([0, 8]),
    height: 'auto',
    overflow: 'hidden',
});

export const Top: StyleRule = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    height: pxToRem(40),
    width: '100%',
    padding: pxArrayToRem([10, 0, 6, 0]),
    [`& .${imageClassName}`]: {
        background: theme.siteVariables.colors.primitive.white,
    },
});

export const CloseButton: StyleRule = () => ({
    cursor: 'pointer',
    margin: pxToRem(16),
    position: 'absolute',
    top: 0,
    right: 0,
    width: pxToRem(16),
    height: pxToRem(16),
});

export const ColoursList: StyleRule = () => ({
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    margin: 0,
});

export const PaletteTitle: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([16, 0, 8, 0]),
    ...theme.siteVariables.textStyles.Text.Medium65,
    fontSize: theme.siteVariables.fontSizes['caption04'],
    lineHeight: pxToRem(17.5),
    color: theme.siteVariables.colors.charcoal['100'],
});

export const PreviewTitle: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([16, 0, 0, 0]),
    ...theme.siteVariables.textStyles.Text.Medium65,
    fontSize: theme.siteVariables.fontSizes['caption04'],
    lineHeight: pxToRem(17.5),
    color: theme.siteVariables.colors.charcoal['100'],
});

export const PreviewSubTitle: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([0, 0, 8, 0]),
    ...theme.siteVariables.textStyles.Text.Medium65,
    fontSize: pxToRem(10),
    lineHeight: pxToRem(12.5),
    color: theme.siteVariables.colors.charcoal['100'],
});

export const paletteAnimation = {
    open: {
        transform: `translateX(${pxToRem(0)})`,
        width: 'auto',
        height: 'auto',
        transition: {
            duration: 0.2,
            delay: 0.2,
            delayChildren: 0.2,
        },
    },
    closed: {
        transform: `translateX(${pxToRem(-236)})`,
        width: 0,
        height: 0,
        transition: { duration: 0.2 },
    },
};

export const headAnimation = {
    open: {
        opacity: 1,
        transition: { duration: 0.2 },
    },
    closed: {
        opacity: 1,
        transition: { duration: 0.2 },
    },
};

export const bodyAnimation = {
    open: {
        transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
    closed: {
        transition: { staggerChildren: 0.1, staggerDirection: -1 },
    },
};

export const mobilePreviewAnimation = {
    open: {
        transform: `translateY(${pxToRem(0)})`,
        height: 'auto',
        opacity: 1,
        transition: { duration: 0.2 },
    },
    closed: {
        transform: `translateY(${pxToRem(118)})`,
        height: 0,
        opacity: 0,
        transition: { duration: 0.2 },
    },
};
